module.exports = __webpack_public_path__ + "static/media/entrant.f900c24b.jpg";